import {
  Maybe,
  CardType,
  CardPaperType,
} from '../../../__generated__/globalTypes'

import {
  GiftVariationFragment,
  isGiftVariationFragment,
} from './GiftVariationFragment'

import { SendDelayFragment, isSendDelayFragment } from './SendDelayFragment'

import itemFragmentRawString from '../ItemFragment.graphql'

export const itemFragmentString = itemFragmentRawString

export type ItemFragment = {
  __typename: 'Item'
  id: string
  description: Maybe<string>
  itemCode: string
  price: number
  name: Maybe<string>
  image: Maybe<string>
  campaign: Maybe<{
    __typename: 'Campaign'
    id: string
    name: string
    isShareable: boolean
    lines: {
      name: Maybe<string>
      card: Maybe<{
        id: string
        type: CardType
        isHorizontal: boolean
        paperType: CardPaperType
        tinyThumb: string
        frontPreviewUrl: string
        insidePreviewUrl: Maybe<string>
        flapPreviewUrl: Maybe<string>
        backPreviewUrl: string
        sendableCard: Maybe<{
          id: string
          title: string
        }>
        panels: {
          name: string
          previewUrl: string
          isFullBleed: boolean
          width: number
          height: number
        }[]
      }>
      giftVariation: Maybe<GiftVariationFragment>
      sendDelay: SendDelayFragment
    }[]
  }>
}

export const isItemFragment = (fragment: any): fragment is ItemFragment =>
  fragment &&
  fragment.__typename === 'Item' &&
  typeof fragment.id === 'string' &&
  (fragment.description === null || typeof fragment.description === 'string') &&
  typeof fragment.itemCode === 'string' &&
  typeof fragment.price === 'number' &&
  (fragment.name === null || typeof fragment.name === 'string') &&
  (fragment.image === null || typeof fragment.image === 'string') &&
  (fragment.campaign === null ||
    (fragment.campaign &&
      fragment.campaign.__typename === 'Campaign' &&
      typeof fragment.campaign.id === 'string' &&
      typeof fragment.campaign.name === 'string' &&
      typeof fragment.campaign.isShareable === 'boolean' &&
      Array.isArray(fragment.campaign.lines) &&
      fragment.campaign.lines
        .slice(0, 5)
        .reduce(
          (accum: any, next: any) =>
            accum &&
            next &&
            (next.name === null || typeof next.name === 'string') &&
            (next.card === null ||
              (next.card &&
                typeof next.card.id === 'string' &&
                (next.card.type === 'POSTCARD' ||
                  next.card.type === 'FLATCARD' ||
                  next.card.type === 'TWO_PANEL' ||
                  next.card.type === 'THREE_PANEL' ||
                  next.card.type === 'TWO_PANEL_BIG') &&
                typeof next.card.isHorizontal === 'boolean' &&
                (next.card.paperType === 'STD' ||
                  next.card.paperType === 'PRE' ||
                  next.card.paperType === 'HVY') &&
                typeof next.card.tinyThumb === 'string' &&
                typeof next.card.frontPreviewUrl === 'string' &&
                (next.card.insidePreviewUrl === null ||
                  typeof next.card.insidePreviewUrl === 'string') &&
                (next.card.flapPreviewUrl === null ||
                  typeof next.card.flapPreviewUrl === 'string') &&
                typeof next.card.backPreviewUrl === 'string' &&
                (next.card.sendableCard === null ||
                  (next.card.sendableCard &&
                    typeof next.card.sendableCard.id === 'string' &&
                    typeof next.card.sendableCard.title === 'string')) &&
                Array.isArray(next.card.panels) &&
                next.card.panels
                  .slice(0, 5)
                  .reduce(
                    (accum: any, next: any) =>
                      accum &&
                      next &&
                      typeof next.name === 'string' &&
                      typeof next.previewUrl === 'string' &&
                      typeof next.isFullBleed === 'boolean' &&
                      typeof next.width === 'number' &&
                      typeof next.height === 'number',
                    true,
                  ))) &&
            (next.giftVariation === null ||
              (isGiftVariationFragment(next.giftVariation) as boolean)) &&
            (isSendDelayFragment(next.sendDelay) as boolean),
          true,
        )))
